import React from 'react';
export function Footer() {
  return <footer className="bg-[#0a0e1f] py-6 md:py-8 px-4 text-center border-t border-[#ffffff]/5" data-id="element-85">
      <div className="container mx-auto max-w-3xl" data-id="element-86">
        <h3 className="text-xl font-serif font-bold text-[#d4af37] mb-4 tracking-wider" data-id="element-87">
          🔮 ACADEMIA HOLÍSTICA ARGENTINA™
        </h3>

        <p className="text-[#cbd0e0] text-sm md:text-base leading-relaxed mb-8 max-w-2xl mx-auto opacity-90" data-id="element-88">
          La formación en astrología diseñada para ayudarte a comprender el
          lenguaje de los astros de forma clara, práctica y profesional.
        </p>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-8 mb-10 text-sm text-[#d4af37] font-medium" data-id="element-89">
          <a href="mailto:academiaholisticaargentina@gmail.com" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-90">
            📧 academiaholisticaargentina@gmail.com
          </a>
          <a href="#" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-91">
            📲 Instagram: @academiaholisticaargentina
          </a>
          <a href="#" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-92">
            📘 Facebook: Academia Holística Argentina
          </a>
        </div>

        <div className="text-xs text-[#8b91ad] opacity-70 space-y-4" data-id="element-93">
          <p data-id="element-94">
            © Academia Holística Argentina™ 2026 — Todos los derechos
            reservados.
          </p>
          <p className="font-serif italic text-sm" data-id="element-95">
            ✨ "Comprender tu carta natal es comprender tu potencial."
          </p>
        </div>
      </div>
    </footer>;
}